import * as classNames from 'classnames';
import * as React from 'react';
import { Box } from 'signoxe/components/layout';
import { Button, Icon, TagList } from 'signoxe/components/widgets';
import { ITag } from 'signoxe/types';
import './styles.scss';

export const FilterBar: React.SFC<IFilterBarProps> =
  ({filterByType, tags, filterByAspect, onFilterChange}) => (
    <Box direction="column" className="filter-bar">
      <Box direction="row" alignItems="center" className="filter-row" wrap>
        <Box direction="row" alignItems="center" className="filter-control">
          <span className="label secondary">Type:</span>
          <Icon name="film" size="2rem" title="Show only Videos"
                color={filterByType === 'video' ? '#88f' : 'black'}
                onClick={() => onFilterChange('TYPE', 'video')}/>
          <Icon name="picture-o" size="2rem" title="Show only Images"
                color={filterByType === 'image' ? '#88f' : 'black'}
                onClick={() => onFilterChange('TYPE', 'image')}/>
          <Icon name="code" size="2rem" title="Show only Web Content"
                color={filterByType === 'web' ? '#88f' : 'black'}
                onClick={() => onFilterChange('TYPE', 'web')}/>
          <Icon name="feed" size="2rem" title="Show only Feeds"
                color={filterByType === 'feed' ? '#88f' : 'black'}
                onClick={() => onFilterChange('TYPE', 'feed')}/>
        </Box>
        <Box direction="row" alignItems="center" className="filter-control">
          <span className="label secondary">Aspect Ratio:</span>
          <Button title="Portrait"
                  className={classNames('small', {hollow: filterByAspect !== 'PORTRAIT'})}
                  onClick={() => onFilterChange('ASPECT', 'PORTRAIT')}>Portrait</Button>
          <Button title="Landscape"
                  className={classNames('small', {hollow: filterByAspect !== 'LANDSCAPE'})}
                  onClick={() => onFilterChange('ASPECT', 'LANDSCAPE')}>Landscape</Button>
        </Box>
      </Box>
      <Box direction="row" alignItems="center" className="filter-row">
        <Box direction="row" alignItems="center" className="filter-control">
          <span className="label secondary">Tags:</span>
          <TagList tags={tags}
                   onTagClick={(tag) => onFilterChange('TAGS', tag)}/>
        </Box>
      </Box>
    </Box>
  );

interface IFilterBarProps {
  filterByType: string;
  filterByAspect: string;
  tags: ITag[];
  onFilterChange: (filterType: string, filter: string) => void;
}

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/widgets/FilterBar/index.tsx